/* Cream band, closed top and bottom by ink rules, matching the "Le plus de contributeur·ices" band. */
.status {
  padding: 84px 0;
  background: var(--color-primary-sand-100); /* PRIMARY_SAND_100 */
  border-top: 3px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  border-bottom: 3px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
}

.split {
  border: 3px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  height: 76px;
  box-shadow: var(--plume-shadow-card, 1px 2px 10px 0 rgba(89, 84, 78, 0.12));
}

.sg {
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 3px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  font-size: 19px; /* HEADING_XS */
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.sg:last-child {
  border-right: none;
}

.sliceOne {
  background: var(--color-primary-blue-500); /* PRIMARY_BLUE_500 */
  color: var(--color-primary-grey-000);
}

.sliceTwo {
  background: var(--color-primary-red-500); /* PRIMARY_RED_500 */
  color: var(--color-primary-grey-000);
}

.sliceThree {
  background: var(--color-complementary-yellow); /* COMPLEMENTARY_YELLOW */
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
}

.legend {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  margin-top: 28px;
}

.lg {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.lg__sw {
  width: 18px;
  height: 18px;
  border: 2px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  border-radius: 5px;
  flex: none;
  margin-top: 3px;
}

.lg strong {
  display: block;
  font-size: 16px; /* COPY_M */
  font-weight: 700;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
}

.lg span {
  font-size: 14px; /* COPY_S */
  color: var(--color-primary-sand-900); /* PRIMARY_SAND_900 (text-2) */
}

.pull {
  margin: 44px 0 0;
  padding-top: 32px;
  border-top: 3px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-weight: 700;
  /* HACK: fluid display size — candidate future DS heading scale */
  font-size: clamp(20px, 2.6vw, 30px);
  line-height: 1.3;
  letter-spacing: -0.015em;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  max-width: 52ch;
  text-wrap: pretty;
}

.pull em {
  color: var(--color-primary-red-500); /* PRIMARY_RED_500 */
  font-style: italic;
}

.status__cta {
  margin-top: 44px;
  display: flex;
  justify-content: center;
}

@media (max-width: 1000px) {
  .legend {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .status {
    padding: 56px 0;
  }

  .split {
    height: 60px;
  }

  .sg {
    font-size: 16px; /* COPY_M */
  }
}

@media (max-width: 560px) {
  .legend {
    grid-template-columns: 1fr;
  }
}
